import PropTypes from 'prop-types'

/**
 * This is the CreateDriverLite type definition for the REST model.
 *
 * @typedef {Object} CreateDriverLite
 * @property {string} [userId]  - ID of the user for which a diver will be created
 */
export const createDriverLitePropType = PropTypes.shape({
    userId: PropTypes.string
})
